import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { name: 'Home', path: '/adaptive-homepage', icon: 'Home' },
    // { name: 'Individual Learning', path: '/individual-learning-new', icon: 'User' },
    // { name: 'Organization Solutions', path: '/institutional-solutions-hub', icon: 'Building2' },
    { name: 'About', path: '/about-dream-coders-club', icon: 'Info' },
    { name: 'Contact', path: '/contact-support', icon: 'MessageCircle' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const isActivePath = (path) => {
    return location.pathname === path;
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-background/95 backdrop-blur-md border-b border-border shadow-subtle' 
          : 'bg-transparent'
      }`}
    >
      <div className="w-full">
        <div className="flex items-center justify-between h-16 px-4 lg:px-6">
          {/* Logo */}
          <Link 
            to="/adaptive-homepage" 
            className="flex items-center space-x-3 group"
            onClick={closeMobileMenu}
          >
            {/* <div className="relative">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-accent to-cyber-purple flex items-center justify-center shadow-glow group-hover:shadow-glow-strong transition-all duration-300">
                <Icon name="Code2" size={24} color="white" strokeWidth={2.5} />
              </div>
              <div className="absolute -inset-1 bg-gradient-to-r from-accent to-cyber-purple rounded-lg blur opacity-20 group-hover:opacity-40 transition-opacity duration-300"></div>
            // </div>*/}
            <div className="hidden sm:block">
              <h1 className="text-xl font-bold text-foreground group-hover:text-accent transition-colors duration-300">
                Dream Coders Club
              </h1>
              <p className="text-xs text-muted-foreground font-mono">
                Community-Powered Innovation
              </p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navigationItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 group ${
                  isActivePath(item.path)
                    ? 'text-accent bg-accent/10 shadow-glow'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'
                }`}
              >
                <span className="relative z-10 flex items-center space-x-2">
                  <Icon name={item.icon} size={16} />
                  <span>{item.name}</span>
                </span>
                {isActivePath(item.path) && (
                  <div className="absolute inset-0 bg-gradient-to-r from-accent/20 to-cyber-purple/20 rounded-lg"></div>
                )}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center space-x-3">
            {/* <Link to="/contact-support">
              <Button
                variant="ghost"
                size="sm"
                className="text-muted-foreground hover:text-foreground"
              >
                Sign In
              </Button>
            </Link> */}
            <Link to="/individual-learning-new">
              <Button
                variant="default"
                size="sm"
                className="morphing-cta text-white font-semibold"
              >
                Start Learning
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            className="lg:hidden p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-all duration-300"
            aria-label="Toggle mobile menu"
          >
            <Icon 
              name={isMobileMenuOpen ? "X" : "Menu"} 
              size={24} 
            />
          </button>
        </div>

        {/* Mobile Navigation */}
        <div 
          className={`lg:hidden transition-all duration-300 ease-out ${
            isMobileMenuOpen 
              ? 'max-h-screen opacity-100' :'max-h-0 opacity-0 overflow-hidden'
          }`}
        >
          <div className="px-4 py-4 bg-card/95 backdrop-blur-md border-t border-border">
            <nav className="space-y-2">
              {navigationItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={closeMobileMenu}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-300 ${
                    isActivePath(item.path)
                      ? 'text-accent bg-accent/10 border border-accent/20' :'text-muted-foreground hover:text-foreground hover:bg-muted/50'
                  }`}
                >
                  <Icon name={item.icon} size={18} />
                  <span>{item.name}</span>
                  {isActivePath(item.path) && (
                    <div className="ml-auto w-2 h-2 rounded-full bg-accent"></div>
                  )}
                </Link>
              ))}
            </nav>

            {/* Mobile CTA */}
            <div className="mt-6 pt-4 border-t border-border space-y-3">
              {/* <Button
                variant="outline"
                fullWidth
                className="justify-center"
              >
                Sign In
              </Button> */}
              <Button
                variant="default"
                fullWidth
                className="morphing-cta text-white font-semibold justify-center"
              >
                Start Learning
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-background/80 backdrop-blur-sm z-40"
          onClick={closeMobileMenu}
        />
      )}
    </header>
  );
};

export default Header;